module.exports = __webpack_public_path__ + "1398e1c87dfe19af92fa2db41f6b78ec.svg";